export default __webpack_public_path__ + "static/media/bg_2.62b628e0.png";